import addNotification from "react-push-notification"
export const pushNotification=(title:string,message:string, onClick:any)=>
    {
      addNotification({
        title:title,
        message:message,
        duration:4000,
        icon:`${process.env.PUBLIC_URL}/defaultProfileImage.png`,
        native:true,
        onClick: onClick,
      })
    }
